import React from "react";
type LogProps = React.PropsWithChildren<{}>;
function ApprovalUI(props: LogProps) {
	return <div className="h-full">{props.children}</div>;
}

export default ApprovalUI;
